import { createSlice } from "@reduxjs/toolkit";

const initialState = {
      fallbackContent: false,
      fallbackContentMRList: null,
      fallbackContentSelectedId: null

};

const fallbackContentSlice = createSlice(
      {
            name: "fallbackContent",
            initialState,
            reducers: {
                  setfallbackContent: (state, action) => {
                        state.fallbackContent = action.payload;
                  },
                  setfallbackContentLogout: (state, action) => {
                        state.fallbackContent = false;
                  },
                  setfallbackContentMRList: (state, action) => {
                        state.fallbackContentMRList = action.payload;
                  },
                  setfallbackContentMRListLogout: (state, action) => {
                        state.fallbackContentMRList = null;
                  },
                  setfallbackContentSelectedId: (state, action) => {
                        state.fallbackContentSelectedId = action.payload;
                  },
                  setfallbackContentSelectedIdLogout: (state, action) => {
                        state.fallbackContentSelectedId = null;
                  },
            },
      },
);


export const { setfallbackContent, setfallbackContentSelectedIdLogout, setfallbackContentSelectedId, setfallbackContentLogout, setfallbackContentMRList, setfallbackContentMRListLogout } = fallbackContentSlice.actions;

export default fallbackContentSlice.reducer;
